import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { isTickmillEU, isTickmillUK } from '@utils/companyName.utils'

import { CreateTradingAccountCampaignFormProps } from '../CreateTradingAccountCampaign.types'
import { shouldHideReferral } from '../CreateTradingAccountCampaign.utils'
import { usePlatformData } from './usePlatformData'

export const useNewTradingAccountData = (
  props: CreateTradingAccountCampaignFormProps,
  platformDataProps: ReturnType<typeof usePlatformData>
) => {
  const { account } = props
  const { isCampaign } = platformDataProps
  const { t } = useTranslation()
  const title = isCampaign
    ? t('Trading Account.Add Campaign Trading Account')
    : t('Trading Account.Add Trading Account')
  const renderReferral = useMemo(() => {
    if (shouldHideReferral(props)) return false
    if (isTickmillUK(account) && !account?.introducingBroker) return false
    if (isTickmillEU(account)) return false
    if (account?.affiliate) return false
    return true
  }, [account, props.hasAnyLiveTA, props.ibValidation?.isActive])
  return { title, renderReferral }
}
